export const SYMBOL = "₽";